import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";

const rootElementIds = ["jFtriggerCalc", "eFtriggerCalc", "yFtriggerCalc"];

rootElementIds.forEach((id) => {
	const rootElement = document.getElementById(id);
	if (rootElement && !rootElement.dataset.reactRendered) {
		const root = ReactDOM.createRoot(rootElement);
		root.render(
			<React.StrictMode>
				<App rootElement={rootElement} />
			</React.StrictMode>
		);
		rootElement.dataset.reactRendered = "true";
	}
});
